import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {AppParametricSelector, makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {getHasVisitorExperienceV3} from '../../../store/featureFlags/featureFlagsSelectors';
import {makeGetConversationSelection} from '../../../store/panels/cells/selectors/cellsPanelSelectionSelectors';
import {CellsPanelId, ViewerPanelId} from '../../../store/panels/panelStateBase';
import {
  makeGetContentPage,
  makeGetTopbarPage,
  makeGetViewerPanel,
} from '../../../store/panels/viewer/viewerPanelSelectors';
import {ViewerPanelPageState} from '../../../store/panels/viewer/viewerPanelState';
import {VisitorConversationsViewer} from './visitorConversationsViewer';

/*
 * Props.
 */

interface VisitorConversationsViewerContainerProps {
  cellsPanelId: CellsPanelId;
  panelId: ViewerPanelId;
  hasVisitorExperienceV3: boolean;
}

/*
 * Selectors.
 */

function getCellsPanelId(_state: unknown, props: VisitorConversationsViewerContainerProps) {
  return props.cellsPanelId;
}

function makeGetTopbarConversationSelection(
  getTopbarPage: AppParametricSelector<VisitorConversationsViewerContainerProps, ViewerPanelPageState>,
) {
  const getTopbarParameters = createSelector(getTopbarPage, (page) => page.parameters);

  return makeGetConversationSelection(getTopbarParameters, getCellsPanelId);
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<VisitorConversationsViewerContainerProps>()(() => {
  const getViewerPanel = makeGetViewerPanel();
  const getTopbarPage = makeGetTopbarPage(getViewerPanel);

  return {
    topbarPage: getTopbarPage,
    hasVisitorExperienceV3: getHasVisitorExperienceV3,
    topbarConversationSelection: makeGetTopbarConversationSelection(getTopbarPage),
    contentPage: makeGetContentPage(getViewerPanel),
  };
});

export const VisitorConversationsViewerContainer = connect(mapStateToProps)(VisitorConversationsViewer);
